import { Divider, Stack, Theme, Tooltip } from '@mui/material';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import BottomDrawer from '../../../../elements/BottomDrawer/BottomDrawer';
import MultiLineEllipsis from '../../../../elements/MultiLineEllipsis/MultiLineEllipsis';
import { IssueAction } from '../../types/issues-types';
import IssueCardAction from '../IssueItem/IssueAction';

const IssueDrawer: FC<React.PropsWithChildren<IssueDrawerRndProps>> = ({
  title,
  children,
  loading,
  defaultHeight,
  className,
  onClose,
  onResizeStop,
  isExclude,
  actions,
  issueId,
}) => {
  const { classes } = useStyles();

  return (
    <BottomDrawer
      className={className}
      loading={loading}
      onClose={onClose}
      defaultHeight={defaultHeight}
      onResizeStop={onResizeStop}
      title={
        <div className={classes.issueTitle}>
          <Tooltip title={title} placement='top' arrow>
            <div>
              <MultiLineEllipsis
                lines={3}
                lineHeightCustom={1.4}
                className={classes.title}>
                {title}
                {isExclude && ' [EXCLUDED FROM FUTURE SCANS]'}
              </MultiLineEllipsis>
            </div>
          </Tooltip>
          <div className={classes.issueActions} data-testid='issue-actions'>
            <Divider orientation='vertical' flexItem />
            {actions.map((actionsBlock, i) => (
              <Stack gap={0.5} spacing={0.5} direction='row' key={i}>
                {actionsBlock.map(action => (
                  <IssueCardAction
                    key={action.text}
                    issueId={issueId}
                    {...action}
                  />
                ))}
                {i !== actions.length - 1 && (
                  <Divider orientation='vertical' flexItem />
                )}
              </Stack>
            ))}
            <Divider orientation='vertical' flexItem />
          </div>
        </div>
      }>
      {children}
    </BottomDrawer>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  issueTitle: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  issueActions: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  title: {
    fontWeight: 'bold',
    marginBlockEnd: theme.spacing(0.5),
    marginInlineEnd: theme.spacing(1),
  },
}));
interface IssueDrawerRndProps {
  title: string;
  loading: boolean;
  defaultHeight?: number;
  className?: string;
  onClose(): void;
  onResizeStop?: (height: number) => void;
  isExclude?: boolean;
  actions: IssueAction[][];
  issueId: string;
}

export default IssueDrawer;
